import React from 'react';
import { Body, Caption, Row } from 'src/components';
import { IconProps } from 'src/components/Icons';
import { Weight } from 'src/theme';
import styled from 'styled-components/native';
import { IconSize, Margin, Size } from 'src/constants';
import { useAppTheme } from 'src/providers/AppThemeProvider';

interface Props {
  title: string;
  icon: (props: IconProps) => React.ReactElement;
  items: Array<{ name: string; value: string }>;
}

const InfoCard: React.FC<Props> = ({ title, icon: Icon, items }) => {
  const { colors } = useAppTheme();

  return (
    <CardContent>
      <StyledHeader>
        <Icon color={colors.text} size={IconSize.S} />
        <Headliner>{title}</Headliner>
      </StyledHeader>
      {items.map((item, index) => (
        <Row key={index} justify='space-between'>
          <Caption>{item.name}</Caption>
          <Caption fontWeight={Weight.MEDIUM} textAlign='right'>
            {item.value}
          </Caption>
        </Row>
      ))}
    </CardContent>
  );
};

export default InfoCard;

const StyledHeader = styled.View.attrs({ hideShadow: true })`
  padding-horizontal: ${Margin.Medium}px;
  padding-bottom: ${Margin.Medium}px;
  flex-direction: row;
  align-items: center;
  gap: ${Margin.Medium}px;
`;

const CardContent = styled.View`
  padding-horizontal: ${Margin.ExtraLarge}px;
  gap: ${Size.X2_S}px;
`;

const Headliner = styled(Body)`
  color: ${({ theme }) => theme.colors.text};
  font-weight: ${Weight.BOLD};
  flex: 1;
`;
